import React from "react";
import style from "./Banned.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

const Banned: React.FC = () => {
  return (
    <PageLayout className={style.Banned}>
      <div className={style.InfoCard}>
        <h1 className={style.Title}>
          Ograniczenia ruchu pojazdów powyżej 12T
        </h1>

        <p className={style.Text}>
          Wprowadza się okresowe ograniczenia ruchu pojazdów o DMC {" > "}12 T
          poprzez zakaz ich ruchu na drogach na obszarze całego kraju
          w godzinach <strong>8:00 – 22:00</strong> w dni ustawowo wolne od
          pracy.
        </p>

        <p className={style.Text}>
          Zakaz obowiązuje m.in. w dni: Nowy Rok, pierwszy i drugi dzień
          Wielkiej Nocy, 1 maja, 3 maja, Zielone Świątki, Boże Ciało,
          15 sierpnia, 1 listopada, 11 listopada oraz 25 i 26 grudnia.
        </p>

        <a
          className={style.Button}
          href="https://isap.sejm.gov.pl/isap.nsf/download.xsp/WDU20190001968/O/D20191968.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Zobacz pełne rozporządzenie (PDF)
        </a>
      </div>
    </PageLayout>
  );
};

export default Banned;